<script lang="ts">
  import Dropdown from '$shared/atoms/Dropdown/Dropdown.svelte';
  import Input from '$shared/atoms/Input/Input.svelte';
  import InputGroup from '$shared/atoms/InputGroup/InputGroup.svelte';
  import EmailType, { EmailTypeLabel } from '$provider/lib/apis/models/EmailType';
  import type { IEmail } from '$provider/lib/apis/interfaces/IResponse';
  import * as Utils from '$shared/helpers/utils';
  import { onMount } from 'svelte';

  const EmailTypeList = Utils.getEnumAsCommonList(EmailType, EmailTypeLabel);

  interface Props {
    value?: IEmail | null;
    onchange?: (formData: IEmail) => void;
  }

  let { value = null, onchange }: Props = $props();
  export const isValid = (): boolean => {
    return !!(formData.email && Utils.isEmailValid(formData.email));
  };

  let formData: IEmail = $state({
    email: '',
    type: EmailType.Work
  });

  onMount(() => {
    value && (formData = value);
  });

  const dispatchChanges = (): void => {
    onchange?.(formData);
  };

  const onInputChange = (detail: any): void => {
    formData.email = detail?.value?.trim();
    dispatchChanges();
  };

  const onEmailTypeChange = (detail: CommonList): void => {
    formData.type = detail.id as EmailType;
    dispatchChanges();
  };
</script>

<div class="email-input">
  <InputGroup>
    <Input placeholder="Email" value={formData.email} oninput={onInputChange} />
    <Dropdown
      list={EmailTypeList}
      label={EmailTypeLabel[formData.type]}
      islarge
      onchange={onEmailTypeChange}
    />
  </InputGroup>
</div>
